import React, { ReactElement } from 'react';

interface LoadingIndicatorProps {
  isFetchInProgress?: boolean;
}

const LoadingIndicator = ({ isFetchInProgress = false }: LoadingIndicatorProps): ReactElement => {
  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div style={{
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #4CAF50',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        animation: 'spin 2s linear infinite'
      }}></div>
      <div style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        marginTop: '15px',
        fontSize: '16px',
        color: '#333',
        fontWeight: '500',
        textAlign: 'center'
      }}>
        {isFetchInProgress ? (
          <div>Retrieving Application Data...</div>
        ) : (
          <div>Loading...</div>
        )}
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingIndicator;

